import api from '../token';

export const ListCompraFornecedor = async () => {
  try {
    const response = await api.post('/getCompraFornecedor');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

